import { cx } from '@linaria/core';
import { IconLock, IconGlobe, IconBuilding } from 'components/Icons';
import { baseTheme } from 'styles/utils';
import { visibilityBadgeStyles } from './Visibility.styles';

// TODO: Explore why this isn't in swagger/clarifai-api.ts
export enum VISIBILITY_GETTABLE {
  PUBLIC = 50,
  ORG = 30,
  PRIVATE = 10,
  UNKNOWN_VISIBILITY = 0,
}

export function getVisibilityDisplayText(visibility: VISIBILITY_GETTABLE): string {
  switch (visibility) {
    case VISIBILITY_GETTABLE.PRIVATE:
      return 'Private';
    case VISIBILITY_GETTABLE.ORG:
      return 'Org';
    case VISIBILITY_GETTABLE.PUBLIC:
      return 'Public';
    default:
      return 'Unknown';
  }
}

export interface VisibilityTagProps extends React.HTMLAttributes<HTMLDivElement> {
  visibility: VISIBILITY_GETTABLE;
  text?: string;
  size?: 'sm' | 'lg';
}

export const Visibility = ({ visibility, text, size = 'sm', ...rest }: VisibilityTagProps): JSX.Element => {
  const isPublic = visibility === VISIBILITY_GETTABLE.PUBLIC;
  const isOrg = visibility === VISIBILITY_GETTABLE.ORG;
  const displayText = text || getVisibilityDisplayText(visibility);
  const iconSize = size === 'sm' ? 16 : 20;

  return (
    <div className={cx(visibilityBadgeStyles, rest.className, size)} {...rest}>
      <div className="content">
        {isPublic ? (
          <IconGlobe size={iconSize} color={baseTheme.light.colors.gray500} data-testid="public-icon" />
        ) : isOrg ? (
          <IconBuilding size={iconSize} color={baseTheme.light.colors.gray500} data-testid="org-icon" />
        ) : (
          <IconLock size={iconSize} color={baseTheme.light.colors.gray500} data-testid="private-icon" />
        )}
        <span>{displayText}</span>
      </div>
    </div>
  );
};
